export type DetailsDisplayCardProps = {
  title: string;
  content?: string;
  suffix?: string;
  customIcon?: React.ReactNode;
};

const DetailsDisplayCard = (props: DetailsDisplayCardProps) => {
  return (
    <div className='surface-ground border-round p-3 mt-4 mb-4 text-md'>
      <span className='flex flex-row align-items-baseline gap-1'>
        <p className='font-medium mb-2'>{props.title}</p>
        {props.customIcon}
      </span>

      {props.content && (
        <div className='flex align-items-center gap-2 flex-wrap'>
          <h4 className='mb-0 break-all'>{props.content}</h4>
          {props.suffix && <span className='text-sm'>{props.suffix}</span>}
        </div>
      )}
    </div>
  );
};

export default DetailsDisplayCard;
